export const PURCHASE_PATH = '/purchase'
export const CHILD_PROFILE_PATH = '/child-profile'
export const SETTINGS_PATH = '/settings'
export const REPORTS_PATH = '/parents'
